<template>
  <router-view/>
</template>

<script>
export default {
  name: 'ShellBlank',
};
</script>
